var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-facade',{staticClass:"form-control",attrs:{"masked":true,"placeholder":"+38(0__)___-__-__","mask":"+38(0##)###-##-##","name":"phoneNumber","type":"tel"},on:{"input":_vm.emitPhoneNumber},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }